export default "/_next/static/assets/defaultHeaderImage_3d2600091276f1d118badd007fd55c5f.jpg";